export const viewingContent = {
  title: [
    { text: 'запишитесь ', accent: true },
    { text: 'на просмотр', accent: false },
  ],
  subtitle: [
    { text: 'остались вопросы?', accent: false },
    { text: 'ждём вас в офисе продаж', accent: true },
  ],
  phoneDisplay: '+7 (342) 248 48 57',
  phoneTel: '+73422484857',
  formIntro: [
    { text: 'укажите свои контакты <br /> и менеджер ', accent: true },
    { text: 'свяжется с вами <br />в удобное для вас время', accent: false },
  ],
  phonePlaceholder: '+7 000 000 00 00',
  phoneLabel: 'Введите номер телефона',
  nameLabel: 'Введите имя',
  submitLabel: 'записаться на просмотр',
  consentLabel: 'я даю согласие на получение рекламных и маркетинговых коммуникаций',
  disclaimer:
    'нажимая на кнопку «Записаться на просмотр», вы подтверждаете, что принимаете условия обработки ваших персональных данных в соответствии с <a href="/privacy">Политикой обработки персональных данных</a> и даете свое Согласие на обработку персональных данных',
};
